export const storeName = 'giftWrap';

export default {
    CHOOSE_PRODUCT_WRAP: `${storeName}.CHOOSE_PRODUCT_WRAP`,
    SELECT_PRODUCT_WRAP: `${storeName}.SELECT_PRODUCT_WRAP`,
    SET_PRODUCT_WRAP_METADATA: `${storeName}.SET_PRODUCT_WRAP_METADATA`,
    SET_GIFT_DATA: `${storeName}.SET_GIFT_DATA`,
    SET_GIFT_OPTION_DATA: `${storeName}.SET_GIFT_OPTION_DATA`,
    SET_APPLIED_GIFT_OPTION: `${storeName}.SET_APPLIED_GIFT_OPTION`,
    SET_SELECTED_PRODUCT_WRAP: `${storeName}.SET_SELECTED_PRODUCT_WRAP`,
    UPDATE_WRAP_MESSAGE: `${storeName}.UPDATE_WRAP_MESSAGE`,
    UPDATE_APPLIED_OPTION_MESSAGE: `${storeName}.UPDATE_APPLIED_OPTION_MESSAGE`,
    CLEAN_SELECTED_WRAP_ENTRIES: `${storeName}.CLEAN_SELECTED_WRAP_ENTRIES`,
    SAVE_GIFTOPTIONS: `${storeName}.SAVE_GIFTOPTIONS`,
    REMOVE_GIFTOPTION: `${storeName}.REMOVE_GIFTOPTION`,
    SHOW_EMPTY_MSG_ERROR: `${storeName}.SHOW_EMPTY_MSG_ERROR`,
    ON_CLOSE: `${storeName}.ON_CLOSE`,
    UPDATE_EMPTY_MSG_FLAG: `${storeName}.UPDATE_EMPTY_MSG_FLAG`,
    UPDATE_EMPTY_MSG_FEATURE_FLAG: `${storeName}.UPDATE_EMPTY_MSG_FEATURE_FLAG`,
};
